import moment from "../../../node_modules/moment/moment";
import { InscriptionDocument } from './InscriptionDocument';
import { MultiLanguage } from "../../MultiLanguage";
import { Representative } from "../../Representative";

export class MyInscription {
    private _id: string;
    private _processId: string;
    private _inscriptionDate: moment.Moment;
    private _canCorrect: boolean;
    private _inscriptionDocuments: InscriptionDocument[];
    private _entityId: string;
    private _entityName: string;
    private _processTitle: MultiLanguage;
    private _group: number;
    private _claimsStartDate: moment.Moment;
    private _claimsEndDate: moment.Moment;
    private _claimsPeriodOpen: boolean;
    private _processType: number;
    private _pendingRegistryInscription: boolean;
    private _pendingRegistryCorrect: boolean;
    private _pendingRegistryAttachMerits: boolean;
    private _represented: Representative;
    private _hasAutoScaling: boolean;
    private _canAppealMerits: boolean;
    private _showMeritIncidences: boolean;
    private _canAttachMerits: boolean;
    private _attachMeritsPeriodOpen: boolean;

    constructor(inscription: any) {
        this._id = inscription.inscriptionId;
        this._processId = inscription.processId;
        this._inscriptionDate = moment(inscription.inscriptionDate);
        this._canCorrect = inscription.canCorrect;
        this._inscriptionDocuments = inscription.documents && inscription.documents.every(doc => doc !== null) ? 
            inscription.documents.map(document => new InscriptionDocument(document)) : [];
        this._pendingRegistryInscription = inscription.pendingRegistryInscription;
        this._pendingRegistryCorrect = inscription.pendingRegistryCorrect;
        this._pendingRegistryAttachMerits = inscription.pendingRegistryAttachMerits;
        this._represented = new Representative(inscription.personalDataDetails);
        this._canAppealMerits = inscription.canAppealMerits;
        this._canAttachMerits = inscription.canAttachMerits;
    }

    public setProcessData(process: any, processConfigurationGroup?: any) {
        this._entityId = process.entityId;
        this._processTitle = new MultiLanguage(process.title);
        this._group = processConfigurationGroup ? processConfigurationGroup.filter(processConfig => processConfig.groupType === process.group)[0] : undefined;
        this._claimsStartDate = process.claimsStartDate ? moment(process.claimsStartDate) : null;
        this._claimsEndDate = process.claimsEndDate ? moment(process.claimsEndDate) : null;
        this._claimsPeriodOpen = process.claimsPeriodOpen;
        this._processType = process.processType;
        this._hasAutoScaling = process.autoScaling;
        this._showMeritIncidences = process.showMeritIncidences;
        this._attachMeritsPeriodOpen = process.attachMeritsPeriodOpen;
    }

    public setEntity(entities: any[]) {
        const filteredEntityList = entities.filter(entity => entity.id === this._entityId);
        if (filteredEntityList.length) {
            this._entityName = filteredEntityList[0].name;
        }
    }

    public get id() {
        return this._id;
    }

    public get processId() {
        return this._processId;
    }

    public get inscriptionDate(): moment.Moment {
        return this._inscriptionDate;
    }

    public get canCorrect() {
        return this._canCorrect;
    }

    public set canCorrect(canCorrect: boolean) {
        this._canCorrect = canCorrect;
    }

    public get inscriptionDocuments() {
        return this._inscriptionDocuments;
    }

    public get entityId() {
        return this._entityId;
    }

    public get entityName() {
        return this._entityName;
    }

    public set entityName(entityName: string) {
        this._entityName = entityName;
    }

    public get processTitle() {
        return this._processTitle;
    }

    public set processTitle(processTitle: MultiLanguage) {
        this._processTitle = processTitle;
    }

    public get group() {
        return this._group;
    }

    public get claimsStartDate() {
        return this._claimsStartDate
    }

    public set claimsStartDate(claimsStartDate: moment.Moment) {
        this._claimsStartDate = claimsStartDate;
    }

    public get claimsEndDate() {
        return this._claimsEndDate;
    }

    public set claimsEndDate(claimsEndDate: moment.Moment) {
        this._claimsEndDate = claimsEndDate;
    }

    public get claimsPeriodOpen() {
        return this._claimsPeriodOpen;
    }

    public get processType() {
        return this._processType;
    }

    public get pendingRegistryInscription() {
        return this._pendingRegistryInscription;
    }

    public get pendingRegistryCorrect() {
        return this._pendingRegistryCorrect;
    }

    public get pendingRegistryAttachMerits() {
        return this._pendingRegistryAttachMerits;
    }
    
    public get represented() {
        return this._represented;
    }
    public set represented(represented: Representative) {
        this._represented = represented;
    }
    
    public get canAppealMerits() {
        return this._canAppealMerits;
    }
    
    public get canAttachMerits() {
        return this._canAttachMerits;
    }
    
    public get attachMeritsPeriodOpen() {
        return this._attachMeritsPeriodOpen;
    }

    public get hasAutoScaling() {
        return this._hasAutoScaling;
    }

    public get showMeritIncidences() {
        return this._showMeritIncidences;
    }

}
